
import React from 'react';
import './WhatWeDo.css';
import Typewriter from './Typewriter';
import NeuralNetworkBackground from './NeuralNetworkBackground'; // Import background

const WhatWeDo = React.forwardRef(({ inView }, ref) => {

  const handleInteractionStart = (e) => {
    const button = e.target;
    button.textContent = 'Coming Soon...';
    button.classList.add('btn-pressed');
  };

  const handleInteractionEnd = (e, originalText) => {
    const button = e.target;
    button.textContent = originalText;
    button.classList.remove('btn-pressed');
  };

  return (
    <section id="what-we-do" ref={ref} className="what-we-do-section">
      <NeuralNetworkBackground className="neural-network-background" /> {/* Render background */}
      <div className="content-wrapper" style={{ position: 'relative', zIndex: 1 }}> {/* Wrap content */}
        <div className="container">
          <h2 className="what-we-do-title"><Typewriter id="whatwedo-title" speed={100} replay={inView}>WHAT <span className="highlight-text">WE DO</span></Typewriter></h2>
          <div className="business-items-container">
            <div className="business-item">
              <h3>AI SOLUTIONS</h3>
              <p>We develop innovative AI applications that solve complex problems for consumers and businesses, driving efficiency and enhancing user experiences across various sectors.</p>
              <a href="#" 
                 onMouseDown={handleInteractionStart} 
                 onMouseUp={(e) => handleInteractionEnd(e, 'LEARN MORE')} 
                 onTouchStart={handleInteractionStart} 
                 onTouchEnd={(e) => handleInteractionEnd(e, 'LEARN MORE')} 
                 className="view-more-btn">LEARN MORE</a>
            </div>
            <div className="business-item">
              <h3>DHUMA GAMES</h3>
              <p>Our specialized division, Dhuma Games, leverages AI to create groundbreaking, immersive, and dynamic gaming experiences through AI-driven mechanics and content generation.</p>
              <a href="#" 
                 onMouseDown={handleInteractionStart} 
                 onMouseUp={(e) => handleInteractionEnd(e, 'EXPLORE GAMES')} 
                 onTouchStart={handleInteractionStart} 
                 onTouchEnd={(e) => handleInteractionEnd(e, 'EXPLORE GAMES')} 
                 className="view-more-btn">EXPLORE GAMES</a>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
});

export default WhatWeDo;
